function ds(s) {
    const p = new URLSearchParams();
    if (s.sayfa)
        p.set('sayfa', String(s.sayfa));
    if (s.boyut)
        p.set('boyut', String(s.boyut));
    if (s.durum)
        p.set('durum', s.durum);
    if (s.arama)
        p.set('arama', s.arama);
    const q = p.toString();
    return q ? `?${q}` : '';
}
export async function destekTalepleriniListele(istemci, sorgu = {}) {
    return istemci.istek(`/destek${ds(sorgu)}`);
}
export async function destekTalebiGetir(istemci, id) {
    return istemci.istek(`/destek/${id}`);
}
export async function destekDurumGuncelle(istemci, id, durum) {
    return istemci.istek(`/destek/${id}/durum`, {
        method: 'PATCH',
        body: JSON.stringify({ durum }),
    });
}
export async function destekMesajEkle(istemci, id, govde) {
    return istemci.istek(`/destek/${id}/mesaj`, {
        method: 'POST',
        body: JSON.stringify({ govde }),
    });
}
//# sourceMappingURL=destek.js.map